export const isAccountType = (accountTypeName: string, Auth: AuthReducer.IState) => Auth && Auth.accountTypeName === accountTypeName;
